const inHouseConsultation = ({
	fName,
	lName,
	address1,
	address2,
	email,
	phone,
	zip,
	unit,
	city,
	province,
	message,
}) => (
	<div>
		<style>{`table, th, td {border: 2px solid; border-collapse: collapse;padding:5px;border-color: #dddddd;}`}</style>
		<p>
			{fName} {lName} has requested a consultation
		</p>
		<table role={"presentation"}>
			<tr>
				<td>
					<b>Name</b>
				</td>
				<td>
					{fName} {lName}
				</td>
			</tr>
			<tr>
				<td>
					<b>Address</b>
				</td>
				<td>
					{address1} {address2}
				</td>
			</tr>
			<tr>
				<td>
					<b>Unit</b>
				</td>
				<td>{unit}</td>
			</tr>
			<tr>
				<td>
					<b>City</b>
				</td>
				<td>{city}</td>
			</tr>
			<tr>
				<td>
					<b>Province</b>
				</td>
				<td>{province}</td>
			</tr>
			<tr>
				<td>
					<b>Zip</b>
				</td>
				<td>{zip}</td>
			</tr>
			<tr>
				<td>
					<b>Email</b>
				</td>
				<td>{email}</td>
			</tr>
			<tr>
				<td>
					<b>Phone</b>
				</td>
				<td>{phone}</td>
			</tr>
			<tr>
				<td>
					<b>Message</b>
				</td>
				<td>{message}</td>
			</tr>
		</table>
	</div>
);

const consultation = ({ fName, lName, email, message, phone, inquiry }) => (
	<div>
		<style>{`table, th, td {border: 2px solid; border-collapse: collapse;padding:5px;border-color: #dddddd;}`}</style>
		<p>
			{fName} {lName} has requested a consultation
		</p>
		<table role={"presentation"}>
			<tr>
				<td>
					<b>Name</b>
				</td>
				<td>
					{fName} {lName}
				</td>
			</tr>
			<tr>
				<td>
					<b>Email</b>
				</td>
				<td>{email}</td>
			</tr>
			<tr>
				<td>
					<b>Phone</b>
				</td>
				<td>{phone}</td>
			</tr>
			<tr>
				<td>
					<b>Type of Inquiry</b>
				</td>
				<td>{inquiry}</td>
			</tr>
			<tr>
				<td>
					<b>Message</b>
				</td>
				<td>{message}</td>
			</tr>
		</table>
	</div>
);

export { inHouseConsultation, consultation };
